export interface ChatContextFilters {
    contextTags: { label: string; value: string }[];
    metadataFilter: { key: string; value: string }[];
}

export interface PendingChatContext extends ChatContextFilters {
    datasources: string[];
    datasourceLabel: string;
    boundChatId?: string;
}

const STORAGE_KEY = "cts-pending-chat-context";

export const setPendingChatContext = (
    context: ChatContextFilters & {
        datasources: string[];
        datasourceLabel: string;
    },
): void => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
};

export const peekPendingChatContext = (): PendingChatContext | undefined => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PendingChatContext) : undefined;
};

export const writePendingChatContext = (context: PendingChatContext): void => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
};

export const clearPendingChatContext = (): void => {
    sessionStorage.removeItem(STORAGE_KEY);
};

export const bindPendingChatContext = (chatId: string): void => {
    const context = peekPendingChatContext();
    if (!context || context.boundChatId) return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...context, boundChatId: chatId }));
};
